import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayNomenclatureEndpoint {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/nomenclature/`
        this.webApi = new WebApi()
    }

    async changeNomenclature (request) {
        const response = await this.webApi.post(`${this.url}save`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async createNomenclature (request) {
        const response = await this.webApi.post(`${this.url}create`, request)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return null
    }

    async getAllNomenclatures () {
        const nomenclatures = await this.webApi.post(`${this.url}list`, { id: null, page: 1, limit: -1 })
        console.log('nomenclatures:', nomenclatures)
        if (nomenclatures) {
            if (!nomenclatures.status_code) {
                if (!nomenclatures.error) {
                    return nomenclatures.data
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${nomenclatures.status_code}`)
            }
        }
        return null
    }

    // get nomenclature by filter
    async getNomenclatureByFilter (filter) {
        const nomenclatures = await this.webApi.post(`${this.url}list`, filter)
        console.log('nomenclatures:', nomenclatures)
        if (nomenclatures) {
            if (!nomenclatures.status_code) {
                if (!nomenclatures.error) {
                    return nomenclatures
                } else {
                    return {}
                }
            } else {
                console.error(`Ошибка с кодом: ${nomenclatures.status_code}`)
            }
        }
        return null
    }

    async getNomenclatureForSelection () {
        const response = await this.webApi.get(`${this.url}GetForSelection`)
        if (response) {
            if (!response.status_code) {
                if (!response.error) {
                    return response
                } else {
                    return { error: true, data: [] }
                }
            } else {
                console.error(`Ошибка с кодом: ${response.status_code}`)
            }
        }
        return { error: true, data: [] }
    }
}
